<template>
  <f7-popup id="popup-admin" class="popup-booking">
    <f7-block v-show="loadAvailableBookingDates" class="loading-data">
      <f7-preloader size="30" color="black"></f7-preloader>
    </f7-block>

    <f7-view v-show="!loadAvailableBookingDates">
      <f7-page class="popup-admin-page calendar-page">
        <f7-block-title large>Calendar</f7-block-title>

        <f7-block class="no-padding no-margin-top">
          <div id="booking-calendar"></div>
        </f7-block>

        <f7-swiper
          v-if="availableBookingTimes"
          :params="sliderOption"
          class="select-slider select-slider--booking margin-vertical padding-horizontal"
        >
          <f7-swiper-slide v-for="(time, index) in availableBookingTimes" :key="index">
            <f7-button
              fill
              large
              :class="[
                'select-slider-button',
                { 'select-slider-button--active': selected.time === time }
              ]"
              :color="selected.time === time ? 'lightblue' : 'white'"
              @click="selected.time = time"
            >
              {{
                `from ${format(new Date(time.start), 'HH:mm')} to ${format(
                  new Date(time.end),
                  'HH:mm'
                )}`
              }}
            </f7-button>
          </f7-swiper-slide>
        </f7-swiper>

        <f7-block class=" mt-auto margin-bottom popup-booking-teacher-id">
          <f7-list class="popup-auth-list no-margin-vertical">
            <f7-list-input
              type="text"
              floating-label
              clear-button
              placeholder="Teacher ID"
              :value="teacherId"
              @input="teacherId = $event.target.value"
            ></f7-list-input>
          </f7-list>

          <f7-button fill large @click="updateAvailableBookingDatesPerMonth">
            Update calendar
          </f7-button>
        </f7-block>
      </f7-page>

      <f7-page class="popup-admin-page">
        <f7-block-title large>
          User list

          <f7-link icon-f7="reload_round_fill" @click="getTeachers"></f7-link>
        </f7-block-title>

        <f7-list media-list>
          <f7-list-item
            v-for="teacher in teachers"
            :key="teacher.id"
            :title="`${teacher.name || ''} ${teacher.lastName || ''} (${teacher.id})`"
          >
            <div slot="subtitle">
              <f7-link :href="`mailto:${teacher.email}`" external>{{ teacher.email }}</f7-link>
              <f7-link :href="`tel:${teacher.phone}`" external>{{ teacher.phone }}</f7-link>
            </div>
            <div slot="media" :class="['teacher-avatar', { online: teacher.online }]">
              <div :style="`background-image: url(${BASE_PATH}${teacher.avatar});`"></div>
              <!-- <img :src="`${BASE_PATH}${teacher.avatar}`" /> -->
            </div>
          </f7-list-item>
        </f7-list>
      </f7-page>

      <f7-page class="popup-admin-page">
        <f7-block-title large>
          Bookings on this date

          <f7-link
            v-if="books.length"
            icon-f7="reload_round_fill"
            @click="getCurrentBooksByDateTime"
          ></f7-link>
        </f7-block-title>
        <f7-list media-list>
          <f7-list-item
            v-for="book in books"
            :key="book.id"
            :title="`${book.user.name || ''} ${book.user.lastName || ''}`"
          >
            <div slot="subtitle">
              <f7-link :href="`mailto:${book.user.email}`" external>
                {{ book.user.email }}
              </f7-link>
              <f7-link :href="`tel:${book.user.phone}`" external>
                {{ book.user.phone }}
              </f7-link>
              <span>
                {{
                  `User: ${book.teacher.name || ''} ${book.teacher.lastName || ''} (${
                    book.teacher.id
                  })`
                }}
              </span>
            </div>
            <div
              slot="media"
              :class="[
                'teacher-avatar',
                { online: teachers.find(teacher => teacher.id === book.teacher.id).online }
              ]"
            >
              <div :style="`background-image: url(${BASE_PATH}${book.user.avatar});`"></div>
              <!-- <img :src="`${BASE_PATH}${book.user.avatar}`" /> -->
            </div>
          </f7-list-item>
        </f7-list>

        <f7-block-title large>
          Available users on this date

          <f7-link
            v-if="schedules.length"
            icon-f7="reload_round_fill"
            @click="getCurrentBooksByDateTime"
          ></f7-link>
        </f7-block-title>
        <f7-list media-list>
          <f7-list-item
            v-for="schedule in schedules"
            :key="schedule.id"
            :title="
              `${schedule.teacher.name || ''} ${schedule.teacher.lastName || ''} (${
                schedule.teacher.id
              })`
            "
          >
            <div slot="subtitle">
              <f7-link :href="`mailto:${schedule.teacher.email}`" external>
                {{ schedule.teacher.email }}
              </f7-link>
              <f7-link :href="`tel:${schedule.teacher.phone}`" external>
                {{ schedule.teacher.phone }}
              </f7-link>
            </div>
            <div
              slot="media"
              :class="[
                'teacher-avatar',
                { online: teachers.find(teacher => teacher.id === schedule.teacher.id).online }
              ]"
            >
              <div :style="`background-image: url(${BASE_PATH}${schedule.teacher.avatar});`"></div>
              <!-- <img :src="`${BASE_PATH}${schedule.teacher.avatar}`" /> -->
            </div>
          </f7-list-item>
        </f7-list>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { mapState } from 'vuex';
import { format, addMonths, isSameMonth, isPast, isSameDay } from 'date-fns';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '@/js/helpers/notify.js';
import { BASE_PATH } from '../js/constants/index.js';

export default {
  name: 'PopupAdmin',

  data() {
    return {
      calendar: null,
      sliderOption: {
        slidesPerView: 'auto',
        freeMode: true
      },
      loadAvailableBookingDates: false,
      updateAvailableBookingDates: false,
      teacherId: '',
      teachers: [],
      availableBookingDates: [],
      availableBookingDays: [],
      availableBookingTimes: [],
      selected: {
        date: '',
        time: {}
      },
      schedules: [],
      books: [],
      loading: false
    };
  },

  computed: {
    BASE_PATH: () => BASE_PATH,
    format: () => format,
    ...mapState({
      languages: state => state.languages,
      levels: state => state.levels
    })
  },

  watch: {
    'selected.time'(val) {
      if (val.start && val.end) {
        this.getCurrentBooksByDateTime();
      } else {
        this.schedules = [];
        this.books = [];
      }
    }
  },

  async mounted() {
    this.createCalendar();
    this.loadAvailableBookingDates = true;
    await this.getAvailableBookingDatesPerMonth();
    await this.getTeachers();
    this.loadAvailableBookingDates = false;
  },

  methods: {
    async getTeachers() {
      try {
        const res = await apiRequest('curator/teachers', 'GET', null, true);
        if (res.success) {
          const teachers = res.success
            .map(({ id, role_id, name, last_name, email, avatar, phone, online }) => ({
              id,
              roleId: role_id,
              name,
              lastName: last_name,
              email,
              avatar,
              phone,
              online: !!online
            }))
            .sort((a, b) => (a.online === b.online ? 0 : a.online ? -1 : 1));

          this.teachers = teachers;
        }
      } catch (error) {
        notify({ text: 'Something went wrong 🤯. Please try again.' });
      }
    },

    async getAvailableBookingDatesPerMonth() {
      const date = new Date();
      // const start = format(startOfHour(date), 'dd.MM.yyyy HH:mm');
      // const end = format(addHours(startOfHour(date), 1), 'dd.MM.yyyy HH:mm');
      const start = format(date, 'dd.MM.yyyy');
      const end = format(addMonths(date, 1), 'dd.MM.yyyy');
      const teacherId = this.teacherId ? `/${this.teacherId}` : '';

      try {
        const res = await apiRequest(
          `booking${teacherId}?start=${start}&end=${end}&tz=${new Date().getTimezoneOffset() / 60}`,
          'GET',
          null,
          true
        );

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        this.availableBookingDates = Object.entries(res.success)
          .map(([key, value]) => value && { [format(new Date(key), 'yyyy/MM/dd')]: value })
          .filter(item => item);

        this.availableBookingDays = this.availableBookingDates.map(object => {
          return {
            date: Object.keys(object)[0],
            color: '#ff6189'
          };
        });

        if (this.availableBookingDays.length) {
          this.calendar.setValue(
            this.availableBookingDates && Object.keys(this.availableBookingDates[0])
          );
          this.renderAvailableBookingDays(this.availableBookingDays);
        } else {
          notify({ text: 'No bookings.' });
        }
      } catch (error) {
        notify({ text: 'Something went wrong 🤯. Please try again.' });
      }
    },

    async getCurrentBooksByDateTime() {
      try {
        const { start, end } = this.selected.time;

        const res = await apiRequest(
          `curator/booking?start=${start}&end=${end}`,
          'GET',
          null,
          true
        );

        if (res.error) {
          notify({ text: res.error });
          return;
        }

        const { schedules, books } = res.success;
        const resultShedules = [];

        schedules
          .map(({ id, start, end, teacher }) => ({
            id,
            start,
            end,
            teacher: {
              id: teacher.id,
              avatar: teacher.avatar,
              name: teacher.name,
              lastName: teacher.last_name,
              email: teacher.email,
              phone: teacher.phone
            }
          }))
          .filter(item => {
            let i = resultShedules.findIndex(x => x.teacher.id == item.teacher.id);

            if (i <= -1) {
              resultShedules.push(item);
            }

            return null;
          });

        this.schedules = resultShedules;

        this.books = books.map(({ id, start, end, level_id, language_id, user, teacher }) => ({
          id,
          start,
          end,
          levelId: level_id,
          languageId: language_id,
          user: {
            id: user.id,
            name: user.name,
            lastName: user.last_name,
            avatar: user.avatar,
            email: user.email,
            phone: user.phone
          },
          teacher: {
            id: teacher.id,
            name: teacher.name,
            lastName: teacher.last_name
          }
        }));
      } catch (error) {
        notify({ text: 'Something went wrong 🤯. Please try again.' });
      }
    },

    async updateAvailableBookingDatesPerMonth() {
      this.updateAvailableBookingDates = true;
      this.availableBookingTimes = [];
      await this.getAvailableBookingDatesPerMonth();
      this.renderAvailableBookingDays();
      this.updateAvailableBookingDates = false;
    },

    renderAvailableBookingDays() {
      this.calendar.params.events = this.availableBookingDays;
      this.calendar.update();
    },

    renderAvailableBookingTimesByDay(date) {
      const selectedDate = format(new Date(date), 'yyyy/MM/dd');
      const arrayOfTimesPeriods = this.availableBookingDates.filter(
        object => Object.keys(object)[0] === selectedDate
      );

      if (!arrayOfTimesPeriods.length) {
        this.availableBookingTimes = [];
        return;
      }

      const availableTimes = arrayOfTimesPeriods[0][selectedDate].map(time => ({
        start: time.start,
        end: time.end
      }));

      this.availableBookingTimes = availableTimes;
      this.selected.time = this.availableBookingTimes && {
        start: this.availableBookingTimes[0].start,
        end: this.availableBookingTimes[this.availableBookingTimes.length - 1].end
      };
    },

    createCalendar() {
      this.calendar = this.$f7.calendar.create({
        containerEl: '.calendar-page #booking-calendar',
        dateFormat: 'yyyy.mm.dd',
        disabled: date =>
          isPast(new Date(date)) && !(isSameDay(date, new Date()) && isSameMonth(date, new Date())),
        on: {
          change: (calendar, value) => {
            this.selected.date = value[0];
            this.selected.time = {};
            this.renderAvailableBookingTimesByDay(value[0]);
          }
        }
      });

      this.$once('hook:beforeDestroy', () => {
        this.calendar.destroy();
        this.calendar = null;
      });
    }
  }
};
</script>

<style lang="less">
#popup-admin.popup:not(.popup-tablet-fullscreen) {
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 970px;
    --f7-popup-tablet-height: 526px;
  }
}

#popup-admin {
  .view {
    display: flex;
  }
}

.popup-admin-page.page {
  // position: relative;
  width: 33.33%;

  &:nth-of-type(2) {
    left: 33.33%;
  }

  &:nth-of-type(3) {
    left: 66.66%;

    &::after {
      display: none;
    }
  }

  &::after {
    content: '';
    position: absolute;
    background-color: var(--f7-calendar-row-border-color);
    display: block;
    z-index: 15;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
  }

  .list .item-title {
    white-space: normal;
  }

  .list .item-subtitle {
    display: flex;

    a {
      display: block;
      color: #87919c;

      &:hover {
        color: #ff6189;
      }
    }
  }
}

.popup-booking {
  --f7-calendar-week-header-height: 25px;

  .toolbar.toolbar-top {
    display: none;
  }

  .calendar-week-header .calendar-week-day {
  }

  .page-content-inner {
    display: flex;
  }
}

.loading-booking-calendar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(#ffffff, 0.5);
}

.loading-data {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  top: 50%;
  left: 50%;
  padding: 0 !important;
  margin: 0 !important;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.popup-booking-section {
  flex-basis: 33.3%;
}

.popup-booking-teacher-id {
  display: flex;
  align-items: center;

  .popup-auth-list {
    flex-basis: 50%;
    ul {
      &::before {
        display: none;
      }
    }
  }

  a {
    margin-left: 20px;
    flex-basis: 50%;
  }
}

.select-slider {
  padding: 0 10px;

  --f7-button-large-font-size: 15px;
  --f7-button-fill-text-color: #000000;
  --f7-button-large-font-weight: 400;
  --f7-button-box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.1);

  .swiper-slide {
    padding: 10px 0;

    &:not(:last-of-type) {
      margin-right: 5px !important;
    }
  }

  &--lang {
    margin-bottom: 0px;

    --f7-button-large-height: 57px;
    --f7-button-padding-horizontal: 38px;
    --f7-button-border-radius: 28px;
  }

  &--rate {
    margin-bottom: 0px;

    --f7-button-large-height: auto;
    --f7-button-padding-horizontal: 15px;
    --f7-button-padding-vertical: 15px;
    --f7-button-border-radius: 10px;
  }

  .swiper-slide {
    width: auto !important;
    margin-right: -5px !important;
  }

  &-button {
    margin: 3px 5px 10px;
    display: inline-block;

    &--active {
      --f7-button-box-shadow: none;

      .select-slider-button-image {
        box-shadow: 0 1px 8px 0 rgba(255, 97, 137, 0.5);
      }
    }

    &-image {
      width: 50px;
      height: 50px;
      margin-right: 5px;
      border-radius: 50%;
      background-color: #d8d8d8;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    &-rate-name {
      letter-spacing: -0.36px;
      line-height: 20px;
    }

    &-rate-coast {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;

      b {
        font-size: 25px;
        font-weight: 500;
        color: #000000;
        letter-spacing: -0.6px;
      }
    }

    &-rate-info {
      font-size: 8px;
      color: #9d9d9d;
      letter-spacing: -0.19px;
      line-height: 1;
    }

    &.no-video-permission,
    &.disabled {
      opacity: 0.5;
      cursor: not-allowed !important;
    }
  }
}

.teacher-avatar {
  width: 45px;
  height: 45px;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 50%;
  border: 3px solid var(--f7-list-item-border-color);

  &.online {
    border: 3px solid #4cd964;
  }

  div {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
}
</style>
